export const getRefreshToken = () => {
  const token = localStorage.getItem("ng-ref-token");
  const source = localStorage.getItem("ng-ref-token--source");
  if(token === "undefined" || token === "null") {
    return {}
  }
  return {
    token,
    source: source === "undefined" ? "NG" : source
  }
};

export const setRefreshToken = ({ token, source }) => {
  localStorage.setItem("ng-ref-token", token);
  localStorage.setItem("ng-ref-token--source", source);
};

export const REFRESH_TOKEN_SOURCES = {
  NG: "NG",
  AZURE: "AZURE",
  AUTH0: "AUTH0",
  GOOGLE: "GOOGLE"
}

export const clearLocalStorage = () => localStorage.clear()

export const setIsInsightSelfActivated = ({ insightName, insightGroup }) => {
  localStorage.setItem(btoa(encodeURI(insightName + insightGroup)), "true")
}

export const getIsInsightSelfActivated = ({ insightName, insightGroup }) => {
  if(insightName && insightGroup) {
    return localStorage.getItem(btoa(encodeURI(insightName + insightGroup))) === "true"
  }
  return false;
}

export const RERUN_TOOLTIP_CLOSE_STORAGE_KEY = "is-rerun-tooltips-closed"
export const setIsRerunTooltipClose = isClosed => localStorage.setItem(RERUN_TOOLTIP_CLOSE_STORAGE_KEY, isClosed)
export const getIsRerunTooltipClose = () => localStorage.getItem(RERUN_TOOLTIP_CLOSE_STORAGE_KEY)
